/** Giống nhau */

/**
 * @link https://shopify.dev/api/liquid/filters/string-filters#url_encode
 */
export const url_encode = (liquid: string) => {
  return liquid;
};
